import LogoLoadingSpinner from '@/components/LogoLoadingSpinner/LogoLoadingSpinner';

interface LobbyStatusLoaderProps {
  totalRowCount: number;
  isFetching: boolean;
}

const LobbyStatusLoader = ({ totalRowCount, isFetching }: LobbyStatusLoaderProps) => {
  return (
    <>
      {!totalRowCount && !isFetching && (
        <div className="flex h-[50dvh] w-full flex-col items-center justify-center text-center">
          <p className="text-lg text-ph-gray-white">No tables match your criteria</p>
        </div>
      )}

      {isFetching && totalRowCount && (
        <div className="flex h-25 w-full flex-col items-center justify-center py-2">
          <LogoLoadingSpinner size="23" />
        </div>
      )}
    </>
  );
};

export default LobbyStatusLoader;
